import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { CheckoutHistory } from 'src/app/models/checkout-history';
import { Record, Icon } from 'src/app/models/record';
import { UserService } from 'src/app/services/user.service';
import { ApiService } from 'src/app/services/api.service';
import { Util } from 'src/app/util';

@Component({
  selector: 'app-user-checkout-history-item',
  templateUrl: './user-checkout-history-item.component.html',
  styleUrls: ['./user-checkout-history-item.component.scss'],
})
export class UserCheckoutHistoryItemComponent implements OnInit {
  @Input()
  checkout: CheckoutHistory;

  @Output()
  removed = new EventEmitter<CheckoutHistory>();

  userService: UserService;
  record: Record;
  slug: string;
  icon: Icon;
  shouldStack: boolean;

  constructor(
    userService: UserService,
    private apiService: ApiService
  ) {
    this.userService = userService;
  }

  ngOnInit() {
    this.shouldStack = ['MAGAZINE', 'NEWSPAPER'].includes(this.checkout.format);
    this.apiService.getRecord(this.checkout.recordId).subscribe(
      (record) => {
        this.record = record;
        this.slug = Util.slugifyRecord(record);
      },
      (_) => this.removed.emit(this.checkout)
    );
  }

  onRemoved(checkout: CheckoutHistory) {
    this.removed.emit(checkout);
  }
}
